/**
 * Frozen reference time for deterministic fixture dates.
 * All dates in fixtures derive from this constant.
 * No new Date() or Date.now() allowed elsewhere in src/.
 */
export const FROZEN_NOW = '2026-04-13T17:00:00Z';

export const FROZEN_NOW_MS = new Date(FROZEN_NOW).getTime();
